export const accessMessages = {
  vesselLimit: {
    title: 'Vessel Limit Reached',
    subtitle: 'Your current plan restricts this action',
    message:
      'You have reached the maximum number of vessels allowed on your current plan. To add more vessels, you need to upgrade.',
    bulletPoints: [
      'Free/Trial plan allows 2 active vessel',
      'Upgrade to add unlimited vessels',
    ],
  },

  questionChapterLimit: {
    title: 'Restricted Manage Question Access',
    subtitle: 'Trial plan limitation',
    message:
      'Your current plan allows question assignment only in Chapters 5 and 6. To manage questions in other chapters, please upgrade to a Premium plan.',
    bulletPoints: [
      'Assign questions only in Chapters 5 and 6',
      'Upgrade to unlock full chapter access',
    ],
  },
};
